<template>
<div class="c-competence-card-page">
    <div class="o-width-limiter">
		<competence-card-data-provider :competence-card-id="id">
			<div slot-scope="dataProvider">
				<div class="t-space-between t-margin-bottom-m">
					<button v-if="$can('manage', 'CompetenceCard')" @click="$router.back()" class="c-button c-button--linkstyle">Tillbaka</button>
					<button v-if="displayGetPdfButton" type="button" class="c-button c-button--primary" @click="dataProvider.generatePdf">Hämta PDF</button>
				</div>
				<div v-if="dataProvider.loading" class="c-spinner"></div>
				<div v-if="!path.includes('create-competence-card') && !dataProvider.loading && dataProvider.competenceCard && !dataProvider.competenceCard.id" class="t-margin-top-m">
					Kompetenskort med id {{id}} hittades inte
				</div>
				<h1 v-if="dataProvider.competenceCard.id" class="t-text-style-alpha t-margin-bottom-s t-margin-top-s">
					{{dataProvider.competenceCard.firstName}} 
					{{dataProvider.competenceCard.surName}}
				</h1>
				<div class="c-competence-card-container t-margin-bottom-m">
					<basic-information 
						v-if="dataProvider.competenceCard && !(dataProvider.mode === 'view' && !dataProvider.competenceCard.id) " 
						v-bind="dataProvider.competenceCard.basicInformation"
						:mode="dataProvider.mode"
						:id="dataProvider.competenceCard.id"
						:workplace-options="dataProvider.workplaceOptions"
						@create="dataProvider.create"
						@edit="dataProvider.edit">
					</basic-information>
					<competence-card-competences 
						v-if="dataProvider.competenceCard && dataProvider.competenceCard.id && dataProvider.competenceRows" 
						:rows="dataProvider.competenceRows" 
						:competenceCardId="dataProvider.competenceCard.id">
					</competence-card-competences>
					<competence-card-courses
						v-if="id !== '0' && dataProvider.competenceCard && dataProvider.competenceCard.id && dataProvider.courseRows" 
						:rows="dataProvider.courseRows" 
						:competenceCardId="dataProvider.competenceCard.id">
					</competence-card-courses>
				</div>
			</div>
		</competence-card-data-provider>
    </div>
</div>
</template>

<script>
import CompetenceCardDataProvider from '@/components/competences/competence-card-data-provider/CompetenceCardDataProvider.vue';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import BasicInformation from '@/components/competences/basic-information/BasicInformation.vue';
import CompetenceCardCompetences from '@/components/competences/competence-card-competences/CompetenceCardCompetences.vue';
import CompetenceCardCourses from '@/components/competences/competence-card-courses/CompetenceCardCourses.vue';
export default {
    name: 'CompetenceCardPage',
    components: {
		VueInput,
		BasicInformation,
		CompetenceCardDataProvider,
		CompetenceCardCompetences,
		CompetenceCardCourses
	},
	props: {
		apiUrl: {
			type: String,
			default: ''
		},
		id: {
            type: String,
            default: '0',
		},
	},
	computed: {
		displayGetPdfButton() {
			return this.path.startsWith('/competence-card/');
		},
		path () {
			return this.$route.path;
		}
	},
	created() {
		this.$store.dispatch('competences/setAppData', { apiUrl: this.apiUrl }).then(() => {
			this.$store.dispatch('competences/setSettingsContext');
		});
    }
}
</script>
